let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fCyiw")).then(() => parcelRequire('gDqOR'));